import {useQuery} from '@tanstack/react-query';
import {apiClient} from '@common/http/query-client';
import {BackendResponse} from '@common/http/backend-response/backend-response';
import {Banner} from '@app/admin/banners/banner';

interface Response extends BackendResponse {
  banners: Banner[];
}

export function useActiveBanners() {
  return useQuery({
    queryKey: ['banners/active'],
    queryFn: () => fetchActiveBanners(),
  });
}

function fetchActiveBanners(): Promise<Response> {
  return apiClient.get('banners/active').then(r => r.data);
}
